import { motion } from 'framer-motion';
import ProductCard from './ProductCard';

export default function SectionRow({ id, titulo, subtitulo, produtos, onDetalhes, onWhatsApp, cor = 'blue' }) {
  if (produtos.length === 0) return null;
  const accent = cor === 'red' ? 'text-mk-red' : 'text-mk-blue';
  return (
    <section id={id} data-testid={`section-${id}`} className="scroll-mt-20 py-10 sm:py-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <p className={`text-[11px] font-extrabold uppercase tracking-[0.25em] ${accent}`}>
          {cor === 'red' ? 'Por tempo limitado' : 'Seleção da loja'}
        </p>
        <h2 className="mt-1 font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">{titulo}</h2>
        {subtitulo && <p className="mt-1 text-sm sm:text-base text-slate-500">{subtitulo}</p>}
      </motion.div>
      <div className="mt-5 flex gap-4 overflow-x-auto pb-3 snap-x snap-mandatory sm:grid sm:grid-cols-3 sm:overflow-visible lg:grid-cols-4">
        {produtos.map((p, i) => (
          <div key={p.id} className="w-64 shrink-0 snap-start sm:w-auto">
            <ProductCard produto={p} index={i} onDetalhes={onDetalhes} onWhatsApp={onWhatsApp} />
          </div>
        ))}
      </div>
    </section>
  );
}
